import './Header.css';

const Header = () => {
  return <span onClick={()=>window.scroll(0,0)} className="header"> That's All You Need</span>;
};

export default Header;
